module.exports = __webpack_public_path__ + "img/left.22a294af.png";